<template>
  <el-dialog
    title="请确认您的操作"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="confirm-content">
      <p>确定取消员工授权吗？</p>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="handleConfirm">确认删除</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteRoleStaff } from '@/api/frame/roleStaffApi'

export default {
  name: 'DeleteRoleStaff',
  data() {
    return {
      dialogVisible: false,
      formData: {
        roleId: '',
        staffId: '',
        userId: ''
      }
    }
  },
  methods: {
    open(roleStaff) {
      this.formData = {
        roleId: roleStaff.roleId,
        staffId: roleStaff.userId,
        userId: roleStaff.userId
      }
      this.dialogVisible = true
    },
    async handleConfirm() {
      try {
        const res = await deleteRoleStaff(this.formData)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除员工授权失败:', error)
        this.$message.error('删除员工授权失败')
      }
    },
    handleClose() {
      this.formData = {
        roleId: '',
        staffId: '',
        userId: ''
      }
    }
  }
}
</script>

<style scoped>
.confirm-content {
  text-align: center;
  margin-bottom: 20px;
}
</style>